import { collection, doc, getDoc, getDocs } from "firebase/firestore";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Link, Outlet } from "react-router-dom";
import { db } from "../Firebase";
import Loading from "../components/Loading";

function About() {
  const [aboutdata, setAboutdata] = useState([]);
  const [abouttools, setAbouttools] = useState([]);
  const [loading, setLoading] = useState(false);

  async function getAbout() {
    setLoading(true);
    const docRef = doc(db, "aboutHero", "rzd6CcO92D4IyFlmp5p6");
    await getDoc(docRef).then((response) => {
      setAboutdata(response.data());
    });
    setLoading(false);
  }

  async function getAboutTool() {
    const querySnap = await getDocs(collection(db, "aboutTools"));
    setAbouttools(
      querySnap.docs.map((doc) => {
        return {
          id: doc.id,
          data: doc.data(),
        };
      })
    );
  }

  useEffect(() => {
    getAbout();
    getAboutTool();
  }, []);

  if (loading === true) {
    return <Loading />;
  } else {
    return (
      <div id="container">
        <div className="max-w-[1440px] flex flex-col p-4">
          {/* hero start */}

          <div className="flex flex-col justify-center w-full h-screen">
            <div className="lg:grid grid-cols-9 flex flex-col-reverse">
              <div className="col-span-5 flex flex-col justify-center">
                <p className="text-pink-600">My name is,</p>
                <h1 className="text-4xl lg:text-6xl font-bold text-white">
                  {aboutdata.name}
                </h1>
                <h2 className="text-4xl lg:text-6xl font-bold text-pink-400">
                  {aboutdata.role}
                </h2>
                <p className="text-pink-400 py-4 max-w-[700px]">
                  {aboutdata.intro}
                </p>
                <div>
                  <Link className="pbtn" to="/contact">
                    Contact Me
                  </Link>
                </div>
              </div>

              <div className="col-span-4 pb-4">
                <div className="flex justify-center">
                  <img
                    className="object-cover lg:w-[500px] w-96"
                    src={aboutdata.imgUrl}
                    alt={aboutdata.imgAlt}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* hero end */}

          {/* Tools start */}
          <div className="flex flex-col lg:h-screen my-40 lg:my-0">
            <div className="flex justify-center ">
              <div className="space-y-10">
                <h1 className="text-center font-bold lg:text-7xl text-5xl text-pink-500">
                  Skills
                </h1>
                <div className="grid grid-cols-4 lg:grid-cols-6">
                  {abouttools.map((item) => (
                    <div
                      key={item.id}
                      className="flex flex-col space-y-4 text-center items-center p-4"
                    >
                      <img
                        className="w-16 lg:w-24 lg:h-24 h-16 object-fill"
                        src={item.data.imgUrl}
                        alt=""
                      />
                      <p>{item.data.name}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          {/* Tools end */}

          {/* project start */}
          <div className="flex flex-col space-y-10">
            <div>
              <h1 className="text-center font-bold lg:text-7xl text-5xl text-slate-400">
                Project I've Done
              </h1>
            </div>
            <div className="flex justify-center space-x-2">
              <Link to="/about/react">
                <span className="sbtn">ReactJs</span>
              </Link>
              <Link to="/about/web">
                <span className="sbtn">WebDesign</span>
              </Link>
              <Link to="/about/logo">
                <span className="sbtn">Logo</span>
              </Link>
              {/* <Link to="/about/video">
                <span className="sbtn">Video</span>
              </Link> */}
            </div>

            <div>
              <Outlet />
            </div>
          </div>
          {/* project end */}
        </div>
      </div>
    );
  }
}
export default About;
